import { MESSAGES_EN, type Messages } from './messages/en';
import { MESSAGES_FR } from './messages/fr';
import { MESSAGES_ES } from './messages/es';
import { MESSAGES_DE } from './messages/de';
import { MESSAGES_IT } from './messages/it';
import { MESSAGES_HU } from './messages/hu';
import { MESSAGES_DK } from './messages/dk';

export const DEFAULT_MESSAGES = {
  en: MESSAGES_EN,
  fr: MESSAGES_FR,
  es: MESSAGES_ES,
  de: MESSAGES_DE,
  it: MESSAGES_IT,
  hu: MESSAGES_HU,
  dk: MESSAGES_DK,
};

export type DefaultMessagesKey = keyof typeof DEFAULT_MESSAGES;

declare global {
  // eslint-disable-next-line
  interface IntlMessages extends Messages { }
}
